<template>
  <v-dialog
    v-model="visible"
    persistent
    max-width="100"
  >
    <v-card
      width="100"
      height="100"
      class="d-flex align-center justify-center"
    >
      <v-progress-circular
        size="70"
        indeterminate
        color="primary"
      />
    </v-card>
  </v-dialog>
</template>

<script>

  export default {
    name: 'LoaderDialog',

    props: {
      visible: {
        type: Boolean,
        required: true,
      },
    },
  }
</script>
